module.exports = __webpack_public_path__ + "static/vo-c86f64182b03a3105d76c6566223bc23.mp3";